<div class="partner-card-container mb-4" role="list">
    <ng-container *ngFor="let partner of partnerOfferDeals; let i = index">
        <app-partner-card-V2 [partner]="partner"
                          [appHostURL]="appHostURL"
                          [userInfo]="userInfo"
                          [currentEnvironment]="currentEnvironment"
                          [isLoggedInTokenValid]="isLoggedInTokenValid"
                          role="listitem"
                          aria-labelledby="{{partner.title}}">
        </app-partner-card-V2>
    </ng-container>
</div>
